import { request } from '@/helpers/apiClient';
import { REWARD_CATALOG_CONFIG } from '@/utils/constants/apiConfig/rewardCatalogConfig';

export const getRewardCatalog = (queryParams, searchArr) =>
  request(REWARD_CATALOG_CONFIG.REWARD_CATALOG(queryParams), { data: searchArr });

// export const handleRewardCatalog = async (req_param) => {
//   return await request(REWARD_CATALOG_CONFIG.REVIEW_REWARD_CATALOG, req_param);
// };

export const getRewardCatalogCsvFile = (queryParams, body) =>
  request(REWARD_CATALOG_CONFIG.REWARD_CATALOG_CSV_DOWNLOAD(queryParams), { data: body });

export const downloadTemplate = () =>
  request(REWARD_CATALOG_CONFIG.REWARD_CATALOG_TEMPLATE_DOWNLOAD(), {});

export const handleBulkUploadAPI = (queryParams, body) =>
  request(REWARD_CATALOG_CONFIG.REWARD_CATALOG_BULK_UPLOAD(queryParams), { data: body });